import * as Core from './core';

const prefix = '';
// const postFile = (path: string, params: object) => Core.uploadFile('POST', prefix + path, params);
// const putFile = (path: string, params: object) => Core.uploadFile('PUT', prefix + path, params);
// const patchFile = (path: string, params: object) => Core.uploadFile('PATCH', prefix + path, params);

const post = (path: string, params?: object, ignore403?: boolean) => Core.simpleRequest('POST', prefix + path, params, ignore403);
const patch = (path: string, params?: object, ignore403?: boolean) => Core.simpleRequest('PATCH', prefix + path, params, ignore403);
// const put = (path: string, params?: object, ignore403?: boolean) => Core.simpleRequest('PUT', prefix + path, params, ignore403);

const get = (path: string, params?: object, ignore403?: boolean) => Core.get(prefix + path, params, ignore403);
const del = (path: string, params?: object, ignore403?: boolean) => Core.del(prefix + path, params, ignore403);

// const postFileJson = async (path: string, params: object) => (await postFile(path, params)).json();
// const putFileJson = async (path: string, params: object) => (await putFile(path, params)).json();
// const patchFileJson = async (path: string, params: object) => (await patchFile(path, params)).json();

const postJson = async (path: string, params?: object, ignore403?: boolean) => (await post(path, params, ignore403)).json();
// const patchJson = async (path: string, params?: object, ignore403?: boolean) => (await patch(path, params, ignore403)).json();
// const putJson = async (path: string, params?: object, ignore403?: boolean) => (await put(path, params, ignore403)).json();

const getJson = async (path: string, params?: object, ignore403?: boolean) => (await get(path, params, ignore403)).json();
// const delJson = async (path: string, params?: object, ignore403?: boolean) => (await del(path, params, ignore403)).json();

export const getAccountById = (id: string) => getJson(`/account/${id}`);
export const getAccountSelf = () => get('/account');
export const getAdminSelf = () => getJson('/account/admin');
export const delAdmin = (body: object) => del('/account', body);
export const toggleKyc = (id: string, kyc: boolean) => patch(`/account/${id}/kyc`, {kyc});
export const toggleSuper = (id: string, superB: boolean) => patch(`/account/${id}/super`, {super: superB});
export const toggleDisable = (id: string, disable: boolean) => patch(`/account/${id}/disable`, {disable});
export const postAdmin = (body: object) => postJson('/account/admin', body);

const appendId = (s: string, id?: string) => id ? s + '/' + id : s;
export const getAvailability = (id?: string) => getJson(appendId('/availability', id));
export const patchAvailability = (ranges: string, notes: string, id?: string) => patch(appendId('/availability', id), {ranges, notes});
export const patchAvailabilitySaved = (id?: string) => patch(appendId('/availability-saved', id));
export const getAccounts = () => get('/accounts', {cv: true});
export const getLogs = (user: string) => getJson('/account/logs', {user});
export const postComplete = (user: string, status: boolean) => post('/account/complete', {user, status});
export const patchPic = (id: string | undefined, newUrl: string) => patch(id ? `/account/${id}/pic` : '/account/pic', {newUrl});
export const patchTimezone = (timezone: string) => patch('/timezone', {timezone});



// WEBPACK FOOTER //
// ./src/client/Account.tsx